/**
 * Route wrapper for the results.
 *
 * The screen requires a survey, and the id travels in the URL. With no id there is nothing to
 * show — results are always of one survey (R21) — so the empty state is the list itself rather
 * than a blank page with a picker on it.
 *
 * @module Pages/BUs/Surveys
 */

import type { JSX } from 'react';
import { Navigate, useNavigate, useParams } from 'react-router-dom';
import { SurveyResultsScreen } from './Components/SurveyResults/SurveyResults';

export const SurveyResultsPage = (): JSX.Element => {
  const navigate = useNavigate();
  const { surveyId } = useParams<{ surveyId: string }>();

  if (!surveyId) return <Navigate to='/surveys' replace />;

  return (
    <SurveyResultsScreen
      surveyId={surveyId}
      onBack={() => {
        navigate('/surveys');
      }}
    />
  );
};
